export default "__VITE_ASSET__CCXjqHpn__"